import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    editingQuestionId: null,
    editingCategoryId: null,
    showChangesHistoryDrawer: false,
    showCreateCategoryDrawer: false,
    showCompareWithLmsDrawer: false,
    showCreateQuestionDrawer: false,
}

const questionSlice = createSlice({
    name: 'question',
    initialState,
    reducers: {
        setEditingQuestionId: (state, action) => {
            state.editingQuestionId = action.payload
        },
        setEditingCategoryId: (state, action) => {
            state.editingCategoryId = action.payload
        },
        setShowChangesHistoryDrawer: (state, action) => {
            state.showChangesHistoryDrawer = action.payload
        },
        setShowCreateCategoryDrawer: (state, action) => {
            state.showCreateCategoryDrawer = action.payload
        },
        setShowCompareWithLmsDrawer: (state, action) => {
            state.showCompareWithLmsDrawer = action.payload
        },
        setShowCreateQuestionDrawer: (state, action) => {
            state.showCreateQuestionDrawer = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const questionActions = questionSlice.actions

export default questionSlice.reducer
